// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Mobile base — typography, canvas, scrolling, touch

   Resets the *measure* of the shared markup: the desktop type ramp tops out
   around 34px, which on a 390px viewport reads as a poster rather than an
   app. Everything here is scoped to html.m-app.
   ════════════════════════════════════════════════════════════════════════ */

/* ── box-sizing ─────────────────────────────────────────────────────────
   The app has no global border-box rule — it applies \`box-sizing:
   border-box\` ad hoc in ~100 individual rules instead. That works when a
   layout is hand-tuned at one width, but it means any padding this layer
   adds to a \`width: 100%\` container is added *outside* that width. The
   settings page came out 422px wide inside a 390px viewport for exactly
   this reason: 390 + 16 + 16.

   Setting it once for the mobile layer is what makes a single --m-gutter
   value hold across every screen. It is scoped to html.m-app, so the
   desktop build's existing measurements are untouched — and it explicitly
   skips the bottom navigation, which is hand-tuned and out of scope for
   this layer. */
html.m-app *:not(.bn-bar, .bn-bar *),
html.m-app *:not(.bn-bar, .bn-bar *)::before,
html.m-app *:not(.bn-bar, .bn-bar *)::after {
  box-sizing: border-box;
}

html.m-app {
  /* Stops iOS enlarging text in landscape, which silently breaks the whole
     scale below. */
  text-size-adjust: 100%;
}

html.m-app body {
  font-family: var(--font-sans);
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-body);
  font-weight: var(--m-fw-regular);
  background: var(--m-surface-page);
  color: var(--color-text-primary);
  /* Tap highlight is a browser artifact; every control in this layer draws
     its own :active state instead. */
  -webkit-tap-highlight-color: transparent;
}

/* Inter, with the same fallback stack the web build uses. Only the variable
   face is requested — one file covers 400/500/600/700, so the four weights
   this scale relies on never synthesise. */
html.m-app,
html.m-app body,
html.m-app input,
html.m-app select,
html.m-app textarea,
html.m-app button {
  font-family: var(--font-sans);
}

/* ── Scrolling ──────────────────────────────────────────────────────────
   Momentum scrolling inside the WebView, and no rubber-band chaining out of
   scrollable children into the page behind them (the thing that makes a
   sheet drag the page underneath it on iOS). */
html.m-app body {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: none;
}

html.m-app .m-scroll-x,
html.m-app [data-m-scroll-x] {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  /* Bleeds the rail to the screen edges while keeping the first and last
     item on the 16px gutter — the native "peek" that tells you a row
     scrolls without needing an affordance. */
  margin-inline: calc(var(--m-gutter) * -1);
  padding-inline: var(--m-gutter);
}

html.m-app .m-scroll-x::-webkit-scrollbar,
html.m-app [data-m-scroll-x]::-webkit-scrollbar {
  display: none;
}

/* Anything the app scrolls to programmatically should land under the app bar,
   not behind it. */
html.m-app {
  scroll-padding-top: calc(var(--m-appbar) + var(--m-safe-top) + var(--m-2));
  scroll-behavior: smooth;
}

@media (prefers-reduced-motion: reduce) {
  html.m-app { scroll-behavior: auto; }
}

/* ── Type ramp ──────────────────────────────────────────────────────────
   Element-level so it reaches the thousands of existing headings without
   each screen needing a rule. Individual screens override where a heading
   has a specific job. */
html.m-app h1 {
  font-size: var(--m-fs-page-title);
  line-height: var(--m-lh-tight);
  font-weight: var(--m-fw-bold);
  letter-spacing: var(--m-track-title);
  margin: 0 0 var(--m-2);
}

html.m-app h2 {
  font-size: var(--m-fs-section);
  line-height: var(--m-lh-tight);
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
  margin: 0 0 var(--m-2);
}

html.m-app h3 {
  font-size: var(--m-fs-card-title);
  line-height: var(--m-lh-snug);
  font-weight: var(--m-fw-semibold);
  margin: 0 0 var(--m-1);
}

html.m-app h4,
html.m-app h5,
html.m-app h6 {
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-snug);
  font-weight: var(--m-fw-semibold);
  margin: 0 0 var(--m-1);
}

html.m-app p {
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-body);
  margin: 0 0 var(--m-3);
}

html.m-app small {
  font-size: var(--m-fs-caption);
  line-height: var(--m-lh-snug);
}

/* Long body copy (legal pages, about, FAQ answers) reads better slightly
   softer than primary UI text, and never wider than the gutter. */
html.m-app p,
html.m-app li {
  overflow-wrap: break-word;
}

/* ── Touch targets ──────────────────────────────────────────────────────
   This deliberately does NOT set a blanket \`min-height\` on every <button>.

   An earlier version of this file did, and it was the single most damaging
   rule in the layer. \`html.m-app button\` has higher specificity than the
   component classes it lands on, so it silently overrode their own heights:
   the bottom navigation's 56px items became 44px and the whole bar lost
   12px, and every compact control — quantity steppers, footer social icons,
   the image heart, a 20px-wide "Set" link — was stretched to 44px tall
   without gaining any width, turning square buttons into slivers.

   A height floor is the wrong instrument anyway. It changes how a control
   *looks* in order to fix how it *taps*. Where a control is genuinely too
   small to hit, the fix is to size that control properly in its own rule
   (see buttons.css and the icon-button sizes throughout this layer), which
   sets width and height together and keeps it square.

   Only the two form controls below get a floor here: they are drawn by the
   platform, carry no styling of their own, and are unusably small at their
   UA default. */
html.m-app input[type="checkbox"],
html.m-app input[type="radio"] {
  min-height: 22px;
}

/* Anything opting in to the shared icon-button shape gets a real target in
   BOTH axes, so it stays square. */
html.m-app :is(.m-icon-btn, .icon-btn, .btn-icon) {
  min-width: var(--m-touch);
  min-height: var(--m-touch);
}

/* Nothing in the app should rely on :hover, which on a touch screen sticks
   after a tap until you tap elsewhere. Keep hover styling for stylus/mouse
   only and give touch a real pressed state instead. */
@media (hover: none) {
  html.m-app button:active,
  html.m-app [role="button"]:active,
  html.m-app a:active {
    opacity: 0.72;
  }
}

/* ── Focus ──────────────────────────────────────────────────────────────
   Keyboard focus still matters (external keyboards, switch control, the
   browser build), but it should not fire on touch. */
html.m-app :focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 2px;
  border-radius: var(--m-r-xs);
}

html.m-app :focus:not(:focus-visible) {
  outline: none;
}

/* ── Text selection ─────────────────────────────────────────────────────
   Long-pressing a button or a nav label to get a selection handle is a
   web tell. Content stays selectable; chrome does not. */
html.m-app button,
html.m-app .m-appbar,
html.m-app .bn-bar,
html.m-app [role="tab"],
html.m-app [role="button"] {
  -webkit-user-select: none;
  user-select: none;
}

/* No global transition override here, deliberately.

   A previous version clamped \`transition-duration\` on \`*\` to 140ms, meaning
   to speed up the theme-switch transition App.css declares on \`*\`. But a
   universal selector under \`html.m-app\` scores (0,1,1), which outranks the
   plain component classes it lands on — so instead of shortening one global
   transition it silently retimed every deliberate animation in the app (the
   gallery's 400ms zoom, accordion reveals, progress fills) to 140ms.

   Component timings are chosen per component. Anything in this layer that
   wants a mobile-specific duration sets it on its own selector. */


/* ════════════════════════════════════════════════════════════════════════
   Bottom navigation — out of scope

   BottomNav.js/.css is deliberately untouched by this layer. Its geometry
   (56px items, 12px labels, 22–23px icons, its own safe-area padding) is
   already tuned, and it is the one component that must not shift.

   These resets undo the generic rules above for anything inside the bar, so
   a future addition here cannot reach it by accident. \`all: revert\` would be
   too broad — it would drop the component's own styles too — so each
   property this layer sets globally is reverted individually.
   ════════════════════════════════════════════════════════════════════════ */
/* box-sizing is NOT restated here. The :not() exclusion on the global rule
   above already keeps this layer out; forcing \`content-box\` on top of it was
   a second bug — the nav's own styles set border-box, so the "reset" added
   its padding back on to the 56px and made the bar 58px tall. Leaving the
   property alone is what actually preserves it. */

html.m-app .bn-bar {
  /* body sets 15px/1.5 for the app; the bar inherited that and shifted the
     line box its icons and labels sit in. Restored to the values it has with
     the layer off, so its internal metrics are bit-for-bit unchanged. */
  font-size: 1rem;
  line-height: normal;
}

html.m-app .bn-item {
  /* Restated, not inherited: guards the 56px against any future blanket
     rule in this layer that outranks BottomNav.css on specificity. */
  min-height: 56px;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/base.css"],"names":[],"mappings":"AAAA;;;;;;6EAM6E;;AAE7E;;;;;;;;;;;;gBAYgB;AAChB;;;EAGE,sBAAsB;AACxB;;AAEA;EACE;mBACiB;EAEjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;EAChC;qCACmC;EACnC,wCAAwC;AAC1C;;AAEA;;2CAE2C;AAC3C;;;;;;EAME,6BAA6B;AAC/B;;AAEA;;;+CAG+C;AAC/C;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB;;6CAE2C;EAC3C,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;AACf;;AAEA;mBACmB;AACnB;EACE,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,aAAa,qBAAqB,EAAE;AACtC;;AAEA;;;wBAGwB;AACxB;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;EAGE,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;kEACkE;AAClE;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;gBAmBgB;AAChB;;EAEE,gBAAgB;AAClB;;AAEA;mCACmC;AACnC;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;sDAEsD;AACtD;EACE;;;IAGE,aAAa;EACf;AACF;;AAEA;;qDAEqD;AACrD;EACE,yCAAyC;EACzC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;;yDAEyD;AACzD;;;;;EAKE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;;;;;;;kEAUkE;;;AAGlE;;;;;;;;;;;6EAW6E;AAC7E;;;;kDAIkD;;AAElD;EACE;;wEAEsE;EACtE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;qEACmE;EACnE,gBAAgB;AAClB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Mobile base — typography, canvas, scrolling, touch\n\n   Resets the *measure* of the shared markup: the desktop type ramp tops out\n   around 34px, which on a 390px viewport reads as a poster rather than an\n   app. Everything here is scoped to html.m-app.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── box-sizing ─────────────────────────────────────────────────────────\n   The app has no global border-box rule — it applies `box-sizing:\n   border-box` ad hoc in ~100 individual rules instead. That works when a\n   layout is hand-tuned at one width, but it means any padding this layer\n   adds to a `width: 100%` container is added *outside* that width. The\n   settings page came out 422px wide inside a 390px viewport for exactly\n   this reason: 390 + 16 + 16.\n\n   Setting it once for the mobile layer is what makes a single --m-gutter\n   value hold across every screen. It is scoped to html.m-app, so the\n   desktop build's existing measurements are untouched — and it explicitly\n   skips the bottom navigation, which is hand-tuned and out of scope for\n   this layer. */\nhtml.m-app *:not(.bn-bar, .bn-bar *),\nhtml.m-app *:not(.bn-bar, .bn-bar *)::before,\nhtml.m-app *:not(.bn-bar, .bn-bar *)::after {\n  box-sizing: border-box;\n}\n\nhtml.m-app {\n  /* Stops iOS enlarging text in landscape, which silently breaks the whole\n     scale below. */\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nhtml.m-app body {\n  font-family: var(--font-sans);\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-body);\n  font-weight: var(--m-fw-regular);\n  background: var(--m-surface-page);\n  color: var(--color-text-primary);\n  /* Tap highlight is a browser artifact; every control in this layer draws\n     its own :active state instead. */\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Inter, with the same fallback stack the web build uses. Only the variable\n   face is requested — one file covers 400/500/600/700, so the four weights\n   this scale relies on never synthesise. */\nhtml.m-app,\nhtml.m-app body,\nhtml.m-app input,\nhtml.m-app select,\nhtml.m-app textarea,\nhtml.m-app button {\n  font-family: var(--font-sans);\n}\n\n/* ── Scrolling ──────────────────────────────────────────────────────────\n   Momentum scrolling inside the WebView, and no rubber-band chaining out of\n   scrollable children into the page behind them (the thing that makes a\n   sheet drag the page underneath it on iOS). */\nhtml.m-app body {\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: none;\n}\n\nhtml.m-app .m-scroll-x,\nhtml.m-app [data-m-scroll-x] {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  /* Bleeds the rail to the screen edges while keeping the first and last\n     item on the 16px gutter — the native \"peek\" that tells you a row\n     scrolls without needing an affordance. */\n  margin-inline: calc(var(--m-gutter) * -1);\n  padding-inline: var(--m-gutter);\n}\n\nhtml.m-app .m-scroll-x::-webkit-scrollbar,\nhtml.m-app [data-m-scroll-x]::-webkit-scrollbar {\n  display: none;\n}\n\n/* Anything the app scrolls to programmatically should land under the app bar,\n   not behind it. */\nhtml.m-app {\n  scroll-padding-top: calc(var(--m-appbar) + var(--m-safe-top) + var(--m-2));\n  scroll-behavior: smooth;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app { scroll-behavior: auto; }\n}\n\n/* ── Type ramp ──────────────────────────────────────────────────────────\n   Element-level so it reaches the thousands of existing headings without\n   each screen needing a rule. Individual screens override where a heading\n   has a specific job. */\nhtml.m-app h1 {\n  font-size: var(--m-fs-page-title);\n  line-height: var(--m-lh-tight);\n  font-weight: var(--m-fw-bold);\n  letter-spacing: var(--m-track-title);\n  margin: 0 0 var(--m-2);\n}\n\nhtml.m-app h2 {\n  font-size: var(--m-fs-section);\n  line-height: var(--m-lh-tight);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n  margin: 0 0 var(--m-2);\n}\n\nhtml.m-app h3 {\n  font-size: var(--m-fs-card-title);\n  line-height: var(--m-lh-snug);\n  font-weight: var(--m-fw-semibold);\n  margin: 0 0 var(--m-1);\n}\n\nhtml.m-app h4,\nhtml.m-app h5,\nhtml.m-app h6 {\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-snug);\n  font-weight: var(--m-fw-semibold);\n  margin: 0 0 var(--m-1);\n}\n\nhtml.m-app p {\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-body);\n  margin: 0 0 var(--m-3);\n}\n\nhtml.m-app small {\n  font-size: var(--m-fs-caption);\n  line-height: var(--m-lh-snug);\n}\n\n/* Long body copy (legal pages, about, FAQ answers) reads better slightly\n   softer than primary UI text, and never wider than the gutter. */\nhtml.m-app p,\nhtml.m-app li {\n  overflow-wrap: break-word;\n}\n\n/* ── Touch targets ──────────────────────────────────────────────────────\n   This deliberately does NOT set a blanket `min-height` on every <button>.\n\n   An earlier version of this file did, and it was the single most damaging\n   rule in the layer. `html.m-app button` has higher specificity than the\n   component classes it lands on, so it silently overrode their own heights:\n   the bottom navigation's 56px items became 44px and the whole bar lost\n   12px, and every compact control — quantity steppers, footer social icons,\n   the image heart, a 20px-wide \"Set\" link — was stretched to 44px tall\n   without gaining any width, turning square buttons into slivers.\n\n   A height floor is the wrong instrument anyway. It changes how a control\n   *looks* in order to fix how it *taps*. Where a control is genuinely too\n   small to hit, the fix is to size that control properly in its own rule\n   (see buttons.css and the icon-button sizes throughout this layer), which\n   sets width and height together and keeps it square.\n\n   Only the two form controls below get a floor here: they are drawn by the\n   platform, carry no styling of their own, and are unusably small at their\n   UA default. */\nhtml.m-app input[type=\"checkbox\"],\nhtml.m-app input[type=\"radio\"] {\n  min-height: 22px;\n}\n\n/* Anything opting in to the shared icon-button shape gets a real target in\n   BOTH axes, so it stays square. */\nhtml.m-app :is(.m-icon-btn, .icon-btn, .btn-icon) {\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n}\n\n/* Nothing in the app should rely on :hover, which on a touch screen sticks\n   after a tap until you tap elsewhere. Keep hover styling for stylus/mouse\n   only and give touch a real pressed state instead. */\n@media (hover: none) {\n  html.m-app button:active,\n  html.m-app [role=\"button\"]:active,\n  html.m-app a:active {\n    opacity: 0.72;\n  }\n}\n\n/* ── Focus ──────────────────────────────────────────────────────────────\n   Keyboard focus still matters (external keyboards, switch control, the\n   browser build), but it should not fire on touch. */\nhtml.m-app :focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 2px;\n  border-radius: var(--m-r-xs);\n}\n\nhtml.m-app :focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* ── Text selection ─────────────────────────────────────────────────────\n   Long-pressing a button or a nav label to get a selection handle is a\n   web tell. Content stays selectable; chrome does not. */\nhtml.m-app button,\nhtml.m-app .m-appbar,\nhtml.m-app .bn-bar,\nhtml.m-app [role=\"tab\"],\nhtml.m-app [role=\"button\"] {\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* No global transition override here, deliberately.\n\n   A previous version clamped `transition-duration` on `*` to 140ms, meaning\n   to speed up the theme-switch transition App.css declares on `*`. But a\n   universal selector under `html.m-app` scores (0,1,1), which outranks the\n   plain component classes it lands on — so instead of shortening one global\n   transition it silently retimed every deliberate animation in the app (the\n   gallery's 400ms zoom, accordion reveals, progress fills) to 140ms.\n\n   Component timings are chosen per component. Anything in this layer that\n   wants a mobile-specific duration sets it on its own selector. */\n\n\n/* ════════════════════════════════════════════════════════════════════════\n   Bottom navigation — out of scope\n\n   BottomNav.js/.css is deliberately untouched by this layer. Its geometry\n   (56px items, 12px labels, 22–23px icons, its own safe-area padding) is\n   already tuned, and it is the one component that must not shift.\n\n   These resets undo the generic rules above for anything inside the bar, so\n   a future addition here cannot reach it by accident. `all: revert` would be\n   too broad — it would drop the component's own styles too — so each\n   property this layer sets globally is reverted individually.\n   ════════════════════════════════════════════════════════════════════════ */\n/* box-sizing is NOT restated here. The :not() exclusion on the global rule\n   above already keeps this layer out; forcing `content-box` on top of it was\n   a second bug — the nav's own styles set border-box, so the \"reset\" added\n   its padding back on to the 56px and made the bar 58px tall. Leaving the\n   property alone is what actually preserves it. */\n\nhtml.m-app .bn-bar {\n  /* body sets 15px/1.5 for the app; the bar inherited that and shifted the\n     line box its icons and labels sit in. Restored to the values it has with\n     the layer off, so its internal metrics are bit-for-bit unchanged. */\n  font-size: 1rem;\n  line-height: normal;\n}\n\nhtml.m-app .bn-item {\n  /* Restated, not inherited: guards the 56px against any future blanket\n     rule in this layer that outranks BottomNav.css on specificity. */\n  min-height: 56px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
